import { ShareTypes } from '@dieterApi/questionnaire/useQuestionnaireDocumentShareQuery';

export interface DocumentShareToken {
  localQuestionnaireId: string;
  // CustomTraining: eigene Schulung (hochgeladenes Dokument), siehe customTrainingId
  type: ShareTypes | 'CustomTraining';
  customTrainingId?: string;
  documentNumber: number;
  documentTitle: string;
  questionnaireId?: string;
  applicationId?: string;
  companyName: string;
  withConfirmation: boolean;
  consentFrom?: 'Bewerber' | 'Mitarbeiter' | 'Vertragspartner';
  whitelabelConfigJson?: string;
}

export interface FileShareToken {
  type: 'download' | 'upload';
  companyName: string;
  description?: string;
  fileId?: string;
  fileName?: string;
  topicId?: string;
  userValueIndex?: string;
}

export interface Subcontractor {
  name: string;
  address: string;
  details?: string;
}

export interface SignatureRequestToken {
  requestId: string;
  companyId: string;
  contractId: string;
  companyName: string;
  signerId: string;
  signerName: string;
  signerEmail: string;
  documentLabel: string;
  contractFileId?: string;
  localQuestionnaireId?: string;
  subcontractors: Subcontractor[];
  tomsQuestionnaireId?: string;
}

export interface CompletedSignatureToken {
  requestId: string;
  companyId: string;
  documentLabel: string;
  signee1Name: string;
  signee2Name: string;
}

type TokenTypes = DocumentShareToken | FileShareToken | SignatureRequestToken | CompletedSignatureToken;

export function parseJwt<T = TokenTypes>(token: string): T | undefined {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload: string;
  try {
    jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  } catch (error) {
    console.error('Invalid token');
    return undefined;
  }

  return JSON.parse(jsonPayload);
}
